import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo192 from "../images/assets/logo192.webp"
import { branchdetails } from "api/BranchDetailsApi";
import { getBranchId } from "utility/HeaderConfig";
import { isMobile } from 'react-device-detect';

// eslint-disable-next-line

export default function OrderDetails({ viewCart, total }) {
  const [BranchMobile, setBranchMobile] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getbranchdetails();
  }, []);

  const getbranchdetails = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranchMobile(data.response.mobile);
    });
  };

  const handleClick = (number) => {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      window.location.replace(`tel:${number}`);
    } else if (window.matchMedia("(max-width: 425px)").matches || isMobile) {
      window.location.href = `tel:${number}`;
    } else {
      setIsOpen(true);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="col-md-4  my-sm-0 my-4" style={{ fontFamily: "sans-serif" }}>

      <div className="d-flex justify-content-between" style={{ marginTop: "90px" }}>

        <h6><small>ORDER SUMMARY</small></h6>

        {/* <Link to="" className="text-decoration-none text-info">

          <h6> <small><b>EDIT ORDER</b></small></h6> </Link> */}

      </div>
      <div className="max-w-md mx-auto bg-white  rounded-lg md:max-w-xl mx-2 mt-1" >

        <div className="px-2" tw="py-2 border-b-4 border-custom-100">

          {/* <b>Order Details</b> */}

        </div>
        <table className="table table-borderless m-0 shadow-lg"
          tw=" py-3 px-4 border border-r-0 border-l-0  border-gray-500 border-dashed ">
          <tbody>
            <div className="responsive-cart-table">
              {viewCart.map((list, index) => (
                <div className="cart-item" key={index}>
                  <div className="cart-item-left">
                    <img
                      src={
                        list.images === "Image_Not_Available" ||
                          list.images === "-" ||
                          list.images === null ||
                          list.images === "@#@"
                          ? logo192
                          : list.images?.split("@#@")[0]
                      }
                      alt="Jai Maruthi Jewellery"
                    />
                  </div>
                  <div className="cart-item-middle">
                    <span className="product-name">{list?.productName}</span>
                    <p className="product-code">
                      <i className="bi bi-tag-fill"></i> {list?.productCode}
                    </p>
                    <small className="product-type">{list?.productTypeName}</small>
                  </div>
                  <div className="cart-item-right">
                    ₹ {list?.discountAmt > 0 ? list?.discountAmt?.toFixed(2) : list?.total?.toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
          </tbody>
        </table>

        <div >

          {/* <div >

            <h6 className="lh-lg"><small>Item total</small></h6>
            <h6 className="text-success lh-lg"> <small> Discount (SPLASH) </small> </h6>
            <h6 className="lh-lg" ><small>Sub total</small></h6>
            <h6 className="lh-lg"><small>Wallet</small></h6>
            <h6 className="lh-lg"><small>Shipping</small></h6>
            <h6 className="lh-lg">Order Total</h6>
            <h6 className="lh-lg"><small>Your total savings</small></h6>
            <h6 className="lh-lg"><small>Account</small></h6>

          </div>

          <div>

            <h6 className="lh-lg"><span>{Math.trunc(total).toString()}</span></h6>
            <h6 className="text-success lh-lg"><small>0 </small></h6>
            <h6 className="lh-lg"><span>{Math.trunc(total).toString()}</span></h6>
            <h6 className="lh-lg"> 0</h6>
            <h6 className="lh-lg"> <span>{Math.trunc(total).toString()}</span> </h6>
            <h6 className="lh-lg"> <span>{Math.trunc(total).toString()}</span> </h6>
            <h6 className="lh-lg"><small> 0</small></h6>
            <h6 className="lh-lg" ><small>0</small></h6>

          </div> */}
          <div
            className="price-detail-section orderItem-box rounded"
            tw="border border-custom-100 border-dashed" >
            <p className="text-white mb-2 fw-bold">
              {/* Order Summary ( {viewCart.length} Items ) */}
              Order Summary ({viewCart.length}){" "}
              {`${viewCart.length === 1 ? "Item" : "Items"}`}
            </p>

            {/* <div className="row">
              <div className="label-col col-sm-7 col">
                <p>Sub Total</p>
              </div>
              <div className="price-col col-sm-5 col">
                <p>
                  <span>₹ </span>
                  <span>{total[3]}</span>
                </p>
              </div>
            </div> */}
            {/* <div className="row">
              <div className="label-col col-sm-7 col">
                <p>CGST </p>
              </div>
              <div className="price-col col-sm-5 col">
                <p className="">
                  <span>₹ </span>
                  <span>{total[1]}</span>
                </p>
              </div>
            </div> */}
            {/* <div className="row">
              <div className="label-col col-sm-7 col">
                <p>SGST</p>
              </div>
              <div className="price-col col-sm-5 col">
                <p className="">
                  <span>₹ </span>
                  <span>{total[2]}</span>
                </p>
              </div>
            </div> */}
            <div className="row">
              <div className="label-col col-sm-7 col ">
                <div>
                  <span className="you-pay fw-bold">Total payable</span>
                  <div>
                    <span className="inc-tax" tw="text-xs">
                      {/* <small className="inc-tax" tw="text-xs"> */}
                      (Incl of all taxes.)
                      {/* </small> */}
                    </span>
                  </div>
                </div>
              </div>
              <div className="price-col col-sm-5 col mt-2">
                <span className="you-pay-amt fw-bold text-uppercase">
                  <span>₹ </span>
                  <span>{total.toString()}</span>
                </span>
              </div>
            </div>
          </div>

        </div>

        <div className="shadow-lg mt-2 p-3 text-center bg-white">

          <h6 ><small>Have any queries ? Contact us for your assistance</small></h6>
          <h6>
            <small>
              Call us at
              <span style={{ marginLeft: "5px" }}>
                <Link className="text-info" onClick={() => handleClick(BranchMobile)}>
                  {BranchMobile}
                </Link>
              </span>
              {/* <span style={{ marginLeft: "5px", marginRight: "5px" }}>or</span>
                                <Link className="text-info">Chat with us</Link> */}
            </small>
          </h6>
          {isOpen && (
            <div tw="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50 mt-[-10px]">
              <div tw="bg-white rounded-lg p-4 w-1/4 flex flex-col items-center -mt-40">
                <p tw="text-lg mb-4">Calls are not supported on website.</p>
                <button
                  className="rounded-pill shadow-sm"
                  tw="bg-[#b9f0ff] hover:bg-[#daab20] text-black font-bold py-2 px-4 rounded"
                  onClick={handleClose}
                >
                  OK
                </button>
              </div>
            </div>
          )}

        </div>

        <div

        // className="price-detail-section orderItem-box " 

        // tw="border border-custom-100 border-dashed"

        >
          <p className="text-success mb-2 fw-bold">
            {/* Order Summary ( {viewCart.length} Items ) */}
            {/* Order Summary ({viewCart.length}) {" "}{`${viewCart.length === 1 ? "Item" : "Items"}`} */}
          </p>
          {/* <div className="row">
            <div className="label-col col-sm-7 col">
              <p>Sub Total</p>
            </div>
            <div className="price-col col-sm-5 col">
              <p>
                <span>₹ </span>
                <span>
                  {total[3] && total[3].toFixed(2)}
                    ₹ {list.basePrice.toFixed(2)}
                    {(
                      (viewCart && viewCart.length > 0 && viewCart[0].basePrice) +
                      (viewCart && viewCart.length > 0 && viewCart[0].diamondTotal) +
                      (viewCart && viewCart.length > 0 && viewCart[0].platinumTotal) +
                      (viewCart && viewCart.length > 0 && viewCart[0].secGoldTotal)
                        ).toFixed(2)} 
  
                </span>
              </p>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="label-col col-sm-7 col">
              <p>Tax  3%</p>
            </div>
            <div className="price-col col-sm-5 col">
              <p className="">
                <span>₹ </span>
                <span>
                  {total[1] && total[1].toFixed(2)}
                  {
                    (
                      ((viewCart?.[0]?.saleTaxList?.length > 0 && viewCart[0].saleTaxList[0]?.amount) || 0) +
                      ((viewCart?.[0]?.saleTaxList?.length > 1 && viewCart[0].saleTaxList[1]?.amount) || 0) +
                      (viewCart[0]?.secGoldTax ? parseFloat(viewCart[0].secGoldTax) : 0) +
                      (viewCart[0]?.diamondTax ? parseFloat(viewCart[0].diamondTax) : 0) +
                      (viewCart[0]?.platinumTax ? parseFloat(viewCart[0].platinumTax) : 0)
                    ).toFixed(2)
                  }
                  
                  </span>
              </p>
            </div>
          </div> */}
          {/* {viewCart && viewCart.length > 0  && viewCart[0].hallmarkCharge > 0 && (
             <div className="row">
            <div className="label-col col-sm-7 col">
              {viewCart && viewCart[0].hmTaxPercentage > 0 ?(
                 <p>Hallmark Charge with tax</p>):(<p>Hallmark Charge</p>)}
            </div>
            <div className="price-col col-sm-5 col">
              <p className="">
                <span>₹ </span>
                <span>
                  {(
                      viewCart[0].hallmarkCharge +
                      viewCart[0].hallmarkCharge * (viewCart[0].hmTaxPercentage / 100)
                    ).toFixed(2)}
                </span>
              </p>
            </div>
          </div> 
          )} */}
          <div className="row">
            <div className="label-col col-sm-7 col ">
              {/* <span className="you-pay fw-bold "> Grand Total</span> */}
              <small className="inc-tax" tw="text-xs">
                {" "}
                {/* (Incl of all taxes.) */}
              </small>
            </div>
            <div className="price-col col-sm-5 col">
              <span className="you-pay-amt fw-bold text-uppercase">
                {/* <span>₹ </span> */}
                {/* <span>{total[0] && Math.trunc(total[0])}</span> */}
                <span>
                  {/* {Math.trunc(total)} */}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
